import React from 'react';
import { Row, Col, Typography, Image } from 'antd';
import benuLogo from '../../image/logo.svg';
import suklLogo from '../../image/sukl-verify.png';
import benuReceptLogo from '../../image/BenuRecept_logo.png';
import {CONTACTS, FOOTER_TEXTS} from "../helpers/misc"
import facebookLogo from '../../image/facebook.svg'
import instagramLogo from '../../image/instagram.svg'
import youtubeLogo from '../../image/youtube.svg'
import linkedinLogo from '../../image/linkedin.svg'

const { Title, Text } = Typography;

const Footer = () => {
  return (
    <footer className="app-footer">
      <Row gutter={[24, 24]} className="footer-content" justify="center">
        <Col>
          <Title level={5} className="footer-title footer-title-logo">&nbsp;</Title>
          <div className="footer-links logo-container">
            <a href="http://www.benulekaren.sk/" target="_blank" rel="noopener noreferrer">
              <Image 
                src={benuLogo} 
                alt={FOOTER_TEXTS.benuLogoAlt} 
                className="footer-logo" 
                preview={false}
                height={40}
              />
            </a>
            <a 
              href="https://www.sukl.sk/sk/inspekcia/lekarenstvo/internetovy-vydaj-liekov-a-zdravotnickych-pomocok/zoznam-subjektov-vykonavajucich-internetovy-vydaj?page_id=3426" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Image 
                src={suklLogo} 
                alt={FOOTER_TEXTS.suklLogoAlt} 
                className="footer-logo" 
                preview={false}
                height={40}
              />
            </a>
            <a href="https://www.benurecept.sk/" target="_blank" rel="noopener noreferrer">
              <Image 
                src={benuReceptLogo} 
                alt={FOOTER_TEXTS.receptLogoAlt} 
                className="footer-logo" 
                preview={false}
                height={40}
              />
            </a>
          </div>
        </Col>
        
        <Col>
          <Title level={5} className="footer-title">{FOOTER_TEXTS.operatorTitle}</Title>
          <Text className="footer-text">
            {FOOTER_TEXTS.operatorInfo.split('\n').map((line, i) => <React.Fragment key={i}>{line}<br /></React.Fragment>)}
          </Text>
        </Col>
        
        <Col>
          <Title level={5} className="footer-title">{FOOTER_TEXTS.contactsTitle}</Title>
          <Text className="footer-text">
            {FOOTER_TEXTS.emailLabel}{' '}<a className="contact" href={`mailto:${CONTACTS.email}`}>{CONTACTS.email}</a><br />
            {FOOTER_TEXTS.phoneLabel}{' '}<a className="contact" href={`tel:${CONTACTS.phone.replace(/\s/g, "")}`}>{CONTACTS.phone}</a>
          </Text>
        </Col>
        
        <Col>
          <Title level={5} className="footer-title">{FOOTER_TEXTS.termsTitle}</Title>
          <div className="footer-links" style={{flexDirection: "column"}}>
            <a
              href="https://www.benulekaren.sk/vernostny-program" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              {FOOTER_TEXTS.loyaltyProgram}
            </a>
            <a
              href="https://www.benulekaren.sk/data/images/_orig/4/2_181164.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              {FOOTER_TEXTS.generalTerms}
            </a>
          </div>
        </Col>

        <Col>
          <Title level={5} className="footer-title footer-title-logo">&nbsp;</Title>
          <div className="footer-links logo-container social-app-container">
            <a href="https://www.facebook.com/benulekarensk/" target="_blank" rel="noopener noreferrer">
              <Image
                src={facebookLogo}
                alt="benulekarensk facebook"
                preview={false}
                width={28}
                height={28}
              />
            </a>
            <a
              href="https://www.instagram.com/benu_lekaren/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src={instagramLogo}
                alt="benulekarensk instagram"
                preview={false}
                width={30}
                height={30}
              />
            </a>
            <a href="https://www.youtube.com/@benulekaren6246/videos" target="_blank" rel="noopener noreferrer">
              <Image
                src={youtubeLogo}
                alt="benulekarensk youtube"
                preview={false}
                width={28}
                height={28}
              />
            </a>
            <a href="https://www.linkedin.com/company/benu-slovensko/" target="_blank" rel="noopener noreferrer">
              <Image
                src={linkedinLogo}
                alt="benulekarensk linkedin"
                preview={false}
                width={28}
                height={28}
              />
            </a>
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
